// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/UpSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareOutlinedSvg
  }));
};

UpSquareOutlined.displayName = 'UpSquareOutlined';
export default React.forwardRef(UpSquareOutlined);